import superagent from 'superagent'
import ReactGA from 'react-ga'
import { setLastLogin } from '../lib/last-login'

export const login = auth => {
  return {
    type: 'LOGIN',
    payload: auth
  }
}
export const logout = () => {
  return { type: 'LOGOUT' }
}

export const expiredTokenLogout = () => {
  return { type: 'EXPIRED_TOKEN_LOGOUT' }
}

// The social endpoints create an account when the identity doesn't match one. That is
// right for sign-up, but from the Login screen it quietly hands people a new, empty
// account instead of telling them they used a different login (WEB-7114). Login passes
// { createUser: false } and gets a 404 back instead.
const createUserQuery = createUser => (createUser ? '' : '?createUserOnAuthFailure=false')

export const facebokLoginRequest = (fbAuthObj, { createUser = true } = {}) => (dispatch, getState) => {
  ReactGA.event({
    category: 'User',
    action: 'Logged in with FaceBook'
  })
  return new Promise((resolve, reject) => {
    superagent
      .post(`${__API_URI__}/auth/fbauth${createUserQuery(createUser)}`)
      .set('Content-Type', 'application/json')
      .set('Platform', 'Web')
      .set('Version', `${__version__}`)
      .send(JSON.stringify(fbAuthObj))
      .end((err, res) => {
        if (err) {
          $('.facebook-button').show()
          reject(err)
        } else {
          let token = JSON.parse(res.text)
          token.accessToken.fbAuth = true
          setLastLogin('facebook', token.email || fbAuthObj.email)
          setTimeout(() => {
            let user = getState().user
            Countly.q.push(() => {
              Countly.user_details({
                name: `${user.fullName}`,
                email: `${user.email}`
              })
              Countly.userData.increment('Login', '1')
              Countly.userData.set('LoginSource', '{facebook}')
            })
          }, 3000)
          resolve(err, res.body)
          dispatch(logout())
          dispatch(login(token.accessToken))
        }
      })
  })
}

export const facebookLoginRequestFreeTrial = fbAuthObj => (dispatch, getState) => {
  ReactGA.event({
    category: 'User',
    action: 'Logged in with Facebook free trial'
  })
  return new Promise(resolve => {
    superagent
      .post(`${__API_URI__}/auth/fbauth?var=Eastmans`)
      .set('Content-Type', 'application/json')
      .set('Platform', 'Web')
      .set('Version', `${__version__}`)
      .send(JSON.stringify(fbAuthObj))
      .end((err, res) => {
        if (err) {
          $('.facebook-button').show()
        } else {
          let token = JSON.parse(res.text)
          token.accessToken.fbAuth = true
          setLastLogin('facebook', token.email || fbAuthObj.email)
          setTimeout(() => {
            let user = getState().user
            Countly.q.push(() => {
              Countly.user_details({
                name: `${user.fullName}`,
                email: `${user.email}`
              })
              Countly.userData.increment('Login', '1')
              Countly.userData.set('LoginSource', '{facebook}')
            })
          }, 3000)
          resolve(err, res.body)
          dispatch(logout())
          dispatch(login(token.accessToken))
        }
      })
  })
}

export const googleLoginRequest = (googleAuthObj, { createUser = true } = {}) => (dispatch, getState) => {
  ReactGA.event({
    category: 'User',
    action: 'Logged in with Google'
  })
  return new Promise((resolve, reject) => {
    superagent
      .post(`${__API_URI__}/Auth/GoogleAuth${createUserQuery(createUser)}`)
      .set('Content-Type', 'application/json')
      .set('Platform', 'Web')
      .set('Version', `${__version__}`)
      .send(JSON.stringify(googleAuthObj))
      .end((err, res) => {
        if (err) {
          console.log(`ERROR: ${__API_URI__}/Auth/GoogleAuth ` + err)
          reject(err)
        } else {
          let token = JSON.parse(res.text)
          token.accessToken.GoogleAuth = true
          setLastLogin('google', token.email || googleAuthObj.email)

          console.log(token, '=============>token')

          dispatch(logout())
          dispatch(login(token.accessToken))
          setTimeout(() => {
            let user = getState().user
            Countly.q.push(() => {
              Countly.user_details({
                name: `${user.fullName}`,
                email: `${user.email}`
              })
              Countly.userData.increment('Login', '1')
              Countly.userData.set('LoginSource', '{google}')
            })
          }, 3000)
          resolve(err, res.body)
        }
      })
  })
}


export const appleLoginRequest = (payload, { createUser = true } = {}) => (dispatch, getState) => {
  ReactGA.event({
    category: 'User',
    action: 'Logged in with Apple'
  })
  return new Promise((resolve, reject) => {
    superagent
      .post(`${__API_URI__}/Auth/AppleAuth?createUserOnAuthFailure=${createUser}`)
      .set('Content-Type', 'application/json')
      .set('Platform', 'Web')
      .set('Version', `${__version__}`)
      .send(JSON.stringify(payload))
      .end((err, res) => {
        console.log(res, '==============res')

        console.log(err, '==============err')

        if (err) {
          console.log(`ERROR: ${__API_URI__}/Auth/AppleAuth ` + err)
          reject(err)
        } else {
          let token = JSON.parse(res.text)
          token.accessToken.AppleAuth = true
          setLastLogin('apple', token.email || payload.email)

          dispatch(logout())
          dispatch(login(token.accessToken))
          setTimeout(() => {
            let user = getState().user
            Countly.q.push(() => {
              Countly.user_details({
                name: `${user.fullName}`,
                email: `${user.email}`
              })
              Countly.userData.increment('Login', '1')
              Countly.userData.set('LoginSource', '{apple}')
            })
          }, 3000)
          resolve(err, res.body)
        }
      })
  })
}


export const googleLoginRequestFreeTrial = googleAuthObj => (dispatch, getState) => {
  ReactGA.event({
    category: 'User',
    action: 'Logged in with Google Free Trial'
  })
  return new Promise(resolve => {
    superagent
      .post(`${__API_URI__}/Auth/GoogleAuth?var=Eastmans`)
      .set('Content-Type', 'application/json')
      .set('Platform', 'Web')
      .set('Version', `${__version__}`)
      .send(JSON.stringify(googleAuthObj))
      .end((err, res) => {
        if (err) {
          console.log(`ERROR: ${__API_URI__}/Auth/GoogleAuth?var=Eastmans` + err)
        } else {
          let token = JSON.parse(res.text)
          token.accessToken.GoogleAuth = true
          setLastLogin('google', token.email || googleAuthObj.email)
          dispatch(logout())
          dispatch(login(token.accessToken))
          setTimeout(() => {
            let user = getState().user
            Countly.q.push(() => {
              Countly.user_details({
                name: `${user.fullName}`,
                email: `${user.email}`
              })
              Countly.userData.increment('Login', '1')
              Countly.userData.set('LoginSource', '{google}')
            })
          }, 3000)
          resolve(err, res.body)
        }
      })
  })
}

export const authLoginRequest = bmAuthObj => (dispatch, getState) => {
  ReactGA.event({
    category: 'User',
    action: 'Logged in with Auth'
  })
  return new Promise((resolve, reject) => {
    superagent
      .post(`${__API_URI__}/auth/auth`)
      .set('Content-Type', 'application/json')
      .set('Platform', 'Web')
      .set('Version', `${__version__}`)
      .send(JSON.stringify(bmAuthObj))
      .end((err, res) => {
        if (err) {
          reject(err)
        } else {
          trackLogin(res.body.fullName, res.body.email)
          setLastLogin('email', res.body.email || bmAuthObj.Email)
          dispatch(logout())
          dispatch(login(res.body.accessToken))
          resolve(res.body)
        }
      })
  })
}

// Checks a password without touching the store. authLoginRequest dispatches
// logout() first, which resets ~125 reducers — harmless before a real login,
// because Landing then mounts and initializeApp() refetches everything. When the
// app is already running there is no remount and nothing refetches, so the store
// stays empty and the UI goes blank (WEB-7081). Use this wherever a password is
// being confirmed rather than a session being established.
export const authVerifyPasswordRequest = bmAuthObj => () => {
  return new Promise((resolve, reject) => {
    superagent
      .post(`${__API_URI__}/auth/auth`)
      .set('Content-Type', 'application/json')
      .set('Platform', 'Web')
      .set('Version', `${__version__}`)
      .send(JSON.stringify(bmAuthObj))
      .end((err, res) => {
        if (err) {
          reject(err)
        } else {
          resolve(res.body)
        }
      })
  })
}

export const authRefreshRequest = (currentTimout, logOutCallback) => (dispatch, getState, token) => {
  let refreshToken = getState().auth.refreshToken
  return new Promise((resolve, reject) => {
    superagent
      .get(`${__API_URI__}/auth/refresh/${refreshToken}`)
      .set('Content-Type', 'application/json')
      .set('Authorization', `Bearer ${token}`)
      .set('Platform', 'Web')
      .set('Version', `${__version__}`)
      .end((err, res) => {
        // Always settle. A 401/400 means the refresh token itself is no longer
        // valid (definitive); a network error (res undefined) or 5xx is transient.
        // Previously only 401/400 rejected and everything else left the promise
        // hanging, which silently killed the refresh loop (WEB-7002).
        if (err || !res || !res.ok) {
          const status = res ? res.status : 0
          reject(Object.assign(new Error('auth refresh failed'), { status }))
          return
        }
        const token = res.body
        // currentTimout(token.expiresSeconds)
        resolve(res.body)
        dispatch(login(token))
      })
  })
}

export const createUserRequest = UserObj => (dispatch, getState) => {
  ReactGA.event({
    category: 'User',
    action: 'Created an Account'
  })
  return new Promise((resolve, reject) => {
    superagent
      .post(`${__API_URI__}/user/create`)
      .set('Content-Type', 'application/json')
      .set('Platform', 'Web')
      .set('Version', `${__version__}`)
      .send(JSON.stringify(UserObj))
      .end((err, res) => {
        if (err) {
          reject(err)
        }
        let token = res.body
        trackLogin(res.body.fullName, res.body.email)
        trackCreate()
        setLastLogin('email', res.body.email || UserObj.Email)
        resolve(res.body)
        dispatch(logout())
        dispatch(login(token.accessToken))
      })
  })
}

const trackLogin = (name, email) => {
  Countly.q.push(() => {
    Countly.user_details({
      name: `${name}`,
      email: `${email}`
    })
    Countly.userData.increment('Login', '1')
    Countly.userData.set('LoginSource', '{password}')
  })
}

const trackCreate = () => {
  Countly.q.push([
    'add_event',
    {
      key: 'Create Account',
      count: 1,
      segmentation: {
        'Action Type': 'Account Created'
      }
    }
  ])
}
